export var ObjectsGroupModalActionType;
(function (ObjectsGroupModalActionType) {
    ObjectsGroupModalActionType["CREATE_GROUP"] = "create-group";
    ObjectsGroupModalActionType["EDIT_GROUP"] = "edit-group";
})(ObjectsGroupModalActionType || (ObjectsGroupModalActionType = {}));
